import { I18n } from '@calendly/i18n'
import { MailSendEnvelopeIcon } from '@calendly/ui/components/icons'
import { nanoid } from 'nanoid'

import { buildNotification } from 'components/event_type_edit'

import { EditItem, TimingsWrapper } from './styles'
import { formatEventTypeLockAttributes, getEventTypeLockAttributes } from '../utils'

export const eventTypeCommunicationsInitialValues = ({
  ...rest
}) => ({
  lockingRules: getEventTypeLockAttributes(rest).locking_rules,
  event_type_lock_attributes: getEventTypeLockAttributes(rest),
  rest
})

export const eventCommunicationValuesToServerData = (values) => ({
  event_type_lock_attributes: formatEventTypeLockAttributes(values),
})

// i18n-tasks-use t("publisher.event_type_editor.sections.communications.timings.days")
// i18n-tasks-use t("publisher.event_type_editor.sections.communications.timings.hours")
// i18n-tasks-use t("publisher.event_type_editor.sections.communications.timings.minutes")
const getTimingDescription = ({ timing, notificationName }) => {
  const suffix = notificationName === 'invitee_email_follow_up'
    ? I18n.t('publisher.event_type_editor.sections.communications.timings.after_event')
    : I18n.t('publisher.event_type_editor.sections.communications.timings.before_event')
  const unit = I18n.t(`publisher.event_type_editor.sections.communications.timings.${timing.unit}`, {
    count: timing.interval
  })
  return <div key={nanoid(5)}>{`${timing.interval} ${unit} ${suffix}`}</div>
}

export const getTimingsDescription = ({ eventType, notificationName }) => {
  const timings = buildNotification(eventType, notificationName)?.timings || []
  return (
    <TimingsWrapper>
      {timings.map((timing) => getTimingDescription({ timing, notificationName }))}
    </TimingsWrapper>
  )
}

export const sectionTitles = {
  calendarInvitation: () => I18n.t('publisher.event_type_editor.sections.communications.calendar_invitation'),
  emailConfirmation: () => I18n.t('publisher.event_type_editor.sections.communications.email_confirmation'),
  emailCancellation: () => I18n.t('publisher.event_type_editor.sections.communications.email_cancellation'),
  emailReminders: () => I18n.t('publisher.event_type_editor.sections.communications.email_reminders.title'),
  textReminders: () => I18n.t('publisher.event_type_editor.sections.communications.text_reminders.title'),
  emailFollowUp: () => I18n.t('publisher.event_type_editor.sections.communications.email_follow_up.title')
}

export const buildSectionHandler = (key, title, selectSection) => () => {
  selectSection({ key, title })
}

export const getNotificationTypeCards = (notificationType, selectSection, readOnly = false) => {
  const calendarInvitationTitle = sectionTitles.calendarInvitation()
  const emailConfirmationTitle = sectionTitles.emailConfirmation()
  const emailCancellationTitle = sectionTitles.emailCancellation()

  const calendarInvitationHandler = buildSectionHandler('calendar_invitation', calendarInvitationTitle, selectSection)
  const emailConfirmationHandler = buildSectionHandler('email_confirmation', emailConfirmationTitle, selectSection)
  const emailCancellationHandler = buildSectionHandler('email_cancellation', emailCancellationTitle, selectSection)

  if (notificationType === 'calendar') {
    return [{
      icon: <MailSendEnvelopeIcon size="large" />,
      htmlId: 'invitation-confirmation',
      readOnly,
      sectionHandler: calendarInvitationHandler,
      title: calendarInvitationTitle,
      subtitle: I18n.t('publisher.event_type_editor.sections.communications.invitation_confirmation.immediately_after_booking'),
      menuItems: <EditItem onClick={calendarInvitationHandler} />
    }]
  }

  return [
    {
      icon: <MailSendEnvelopeIcon size="large" />,
      htmlId: 'invitation-confirmation',
      readOnly,
      sectionHandler: emailConfirmationHandler,
      title: emailConfirmationTitle,
      subtitle: I18n.t('publisher.event_type_editor.sections.communications.invitation_confirmation.immediately_after_booking'),
      menuItems: <EditItem onClick={emailConfirmationHandler} />
    },
    {
      icon: <MailSendEnvelopeIcon size="large" />,
      htmlId: 'invitation-cancellation',
      readOnly,
      sectionHandler: emailCancellationHandler,
      title: emailCancellationTitle,
      subtitle: I18n.t('publisher.event_type_editor.sections.communications.invitation_cancellation.if_cancelled'),
      menuItems: <EditItem onClick={emailCancellationHandler} />
    }
  ]
}

export const getTextReminderSubtitle = (isSmsDeactivated, textReminderActivated, eventType) => {
  if (isSmsDeactivated) {
    return I18n.t('publisher.event_type_editor.sections.communications.disabled_by_admin')
  }
  if (textReminderActivated) {
    return getTimingsDescription({ eventType, notificationName: 'invitee_sms_reminder' })
  }
  return null
}
